import * as API from 'es6/core/api';

/*
*  Keeps track of any difference between a machine's
*  local time and the server's time so that time stamps
*  can be kept consistent.
*/
class ServerTimeManager {
  constructor() {
    this._loader = API.getServerTime();
    this._loader.then(this._setServerOffset.bind(this));
  }

  currentTimestamp() {
    const now = new Date();
    now.setTime(now.getTime() + this._serverOffset);
    return now.toISOString();
  }

  then(...args) {
    return this._loader.then(...args);
  }

  _setServerOffset(response) {
    if (!response) { return; }
    const server = new Date(response.timestamp);
    const local = new Date();
    local.setMilliseconds(0);
    this._serverOffset = server - local;
  }
}

export default new ServerTimeManager();
